"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapProps = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const uuid_1 = require("uuid");
const clsx_1 = __importDefault(require("clsx"));
/**
 * A toggle represents a switch that allows the user to turn things on or off.
 * */
const mapProps = (_a) => {
    var { controlId = uuid_1.v4() } = _a, props = __rest(_a, ["controlId"]);
    return {
        checked: props.checked,
        disabled: props.disabled,
        name: props.name,
        id: controlId,
        'aria-labelledby': props.ariaLabelledby,
        'aria-describedby': props.ariaDescribedby,
        'aria-label': props.ariaLabel,
    };
};
exports.mapProps = mapProps;
const useStyles = core_1.makeStyles((theme) => ({
    label: {
        marginLeft: 0,
        '& > .MuiFormControlLabel-label': {
            paddingLeft: '5px',
        },
    },
    labelWitDesc: {
        '& > .MuiFormControlLabel-label': {
            paddingTop: '2px',
        },
    },
}));
/**
 * A toggle represents a switch that allows the user to turn things on or off.
 * */
const Toggle = (_a) => {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    const classes = useStyles();
    const label = (react_1.default.createElement(react_1.default.Fragment, null,
        props.label,
        props.description && (react_1.default.createElement(core_1.Typography, { variant: "subtitle1", component: "div" }, props.description))));
    const handleChange = (_, checked) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(checked);
    };
    return (react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(core_1.Switch, Object.assign({}, mapProps(props), { onChange: handleChange })), label: label, className: clsx_1.default(classes.label, { [classes.labelWitDesc]: props.description }) }));
};
exports.default = Toggle;
//# sourceMappingURL=index.js.map